
import { css } from 'lit';
export default css`
@-webkit-keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide--draggable>.splide__slider>.splide__track,.splide--draggable>.splide__track{-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none;user-select:none}.splide--fade>.splide__slider>.splide__track>.splide__list,.splide--fade>.splide__track>.splide__list{display:block}.splide--fade>.splide__slider>.splide__track>.splide__list>.splide__slide,.splide--fade>.splide__track>.splide__list>.splide__slide{left:0;opacity:0;position:absolute;top:0;z-index:0}.splide--fade>.splide__slider>.splide__track>.splide__list>.splide__slide.is-active,.splide--fade>.splide__track>.splide__list>.splide__slide.is-active{opacity:1;position:relative;z-index:1}.splide--rtl{direction:rtl}.splide--ttb.is-active>.splide__slider>.splide__track>.splide__list,.splide--ttb.is-active>.splide__track>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important;transform-style:preserve-3d}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide__progress__bar{width:0}.splide{outline:none;position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;outline:none;position:relative}.splide__slide img{vertical-align:bottom}.splide__slider{position:relative}.splide__spinner{-webkit-animation:splide-loading 1s linear infinite;animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__track{overflow:hidden;position:relative;z-index:0}.splide{position:relative}.splide__pagination {
  display: none;
}.splide__arrows{position:absolute;bottom:0px;left:0px;z-index:40;display:flex;width:100%;justify-content:center;--tw-bg-opacity:1;background-color:rgba(107, 31, 153, var(--tw-bg-opacity));
  border-radius: 0}.splide__arrow{display:flex;flex-grow:1;align-items:center;
  background: none;
  border: none;}.splide__arrow:hover{cursor:pointer}.splide__arrow:disabled{cursor:not-allowed}.splide__arrow svg {
  fill: white;
  width: 1.25rem;
}.splide__arrow--prev{justify-content:flex-end;}.splide__arrow--prev:after{position:absolute}.splide__arrow--prev:after{height:50%}.splide__arrow--prev:after {
    content: '';
    border-right: 1px solid var(--gray-200);
    right: 50%;
    top: 0.75rem;
  }.splide__arrow--prev svg{justify-self:end}.splide__arrow--prev svg {
    transform: rotate(180deg);
  }::slotted(img){--tw-bg-opacity:1 !important;background-color:rgba(164, 167, 171, var(--tw-bg-opacity)) !important;-o-object-fit:cover !important;object-fit:cover !important;
  border-radius: 0}.splide__slide.is-visible {
  visibility: visible;
}.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}.slide-count{display:none;border-radius:0.25rem;padding-top:0.25rem;padding-bottom:0.25rem;padding-left:0.5rem;padding-right:0.5rem;font-family:Lato, sans-serif;font-size:1.125rem;--tw-text-opacity:1;color:rgba(255, 255, 255, var(--tw-text-opacity));
  background-color: #00000080}@media (min-width: 768px) {
  .splide__arrows{bottom:0px}
  .splide__arrows {
    height: 4.75rem;
    width: 9.25rem;
    border-radius: 0 5px 0 5px;
  }

  .splide__arrow{justify-content:center}
    .splide__arrow--prev:after {
      top: 1.25rem;
    }

  .slide-count {
    display: block;
  }

  .slide-count{position:absolute}

  .slide-count{bottom:1rem}

  .slide-count{right:1rem}

  .slide-count{z-index:50}
}
`;